import React from 'react';
import { Box, Typography } from '@mui/material';

/**
 * @param {object} props
 * @param {string[]} props.rows
 * @param {boolean} [props.muted] use secondary text color (e.g. cart line items)
 */
export default function FinishingDetailRows({ rows, muted }) {
  const sx = muted
    ? { color: 'text.secondary', wordBreak: 'break-word' }
    : { wordBreak: 'break-word' };
  return (
    <Box>
      {rows.map((row, index) => (
        <Typography key={index} variant="body2" component="div" sx={sx}>
          {row}
        </Typography>
      ))}
    </Box>
  );
}
